"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const context_1 = require("./context");
const utils_1 = require("../../utils");
const art_1 = require("../../art");
const hooks_1 = require("./hooks");
exports.OsmosysCanvasPageLoadingState = ({ children }) => {
    const { canvasQueries, ready } = context_1.useOsmosysCanvasPageContext();
    const { hasFailed } = hooks_1.useCanvasQueries(canvasQueries);
    if (ready || hasFailed) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return children ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement(utils_1.OsmosysDiv, { flexColCenteredFilled: true },
        react_1.default.createElement(utils_1.OsmosysDiv, { flexRowCentered: true },
            react_1.default.createElement(art_1.OsmosysIcon, { osysIcon: "spinner", spin: true, size: "2x" }))));
};
//# sourceMappingURL=LoadingState.js.map